import { useSpotKlineComponent } from '@/hooks/use-spot-kline-component'
import classNames from 'classnames'
import { ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { mobileResolutionList, resolutionList, useKlineStore, useResponsive } from 'store'

import { LoadingView } from 'ui-components'
import '../styles/trading-view-layout.scss'
import { Depth } from './Depth'

interface TradingViewProps {}

export const SpotKline = defineComponent<TradingViewProps>({
  setup() {
    const route = useRoute()
    const klineStore = useKlineStore()
    const spotKline = useSpotKlineComponent()
    const { t } = useI18n()
    const responsive = useResponsive()

    onBeforeUnmount(() => {
      klineStore.unsubscribeAll(klineStore.currentSymbolId!)
      klineStore.$dispose()
    })

    onBeforeMount(() => {
      klineStore.currentSymbolId = route.query.symbol ? Number(route.query.symbol) : 22
    })

    const resolution = computed(() => {
      if (responsive.isMobile) {
        return mobileResolutionList
      }
      return resolutionList
    })

    return () => (
      <div class="trading-view-layout" id="trading-view-chart">
        <div class="trad-layout">
          {
            <div class="resolution-list">
              {spotKline.activeKey.value === 'LINE' &&
                resolution.value.map((item) => (
                  <div
                    class={classNames('resolution-item', {
                      active: klineStore.currentResolution === item.value && klineStore.currentResolutionType === item.type,
                    })}
                    key={item.value}
                    onClick={() => spotKline.setResolution(item)}
                  >
                    {t(item.label)}
                  </div>
                ))}
            </div>
          }
          <ElSpace size={24} class="tab">
            <span class={classNames('item', { active: spotKline.activeKey.value === 'LINE' })} onClick={() => spotKline.onStepChange('LINE')}>
              {t('K线图')}
            </span>
            <span class={classNames('item', { active: spotKline.activeKey.value === 'MAP' })} onClick={() => spotKline.onStepChange('MAP')}>
              {t('深度图')}
            </span>
          </ElSpace>
        </div>
        <div
          ref={spotKline.tradingViewMounted}
          class={classNames('trading-view-mounted', {
            'is-ready': !spotKline.loadingChart.value,
          })}
          style={{ display: spotKline.activeKey.value === 'LINE' ? 'block' : 'none' }}
        ></div>
        {spotKline.activeKey.value !== 'LINE' && <Depth />}
        {spotKline.loadingChart.value && (
          <div class="loading-chart">
            <LoadingView color="var(--colors-primary)" />
          </div>
        )}
      </div>
    )
  },
})
